// extracted by mini-css-extract-plugin
module.exports = {"myLocationButton":"DataCollectorMap_myLocationButton__1pdDU","fetchingLocation":"DataCollectorMap_fetchingLocation__3TTck"};